<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/janvegas">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>            

        <v-row>                
            <v-col cols="9">
                <div class="text-left">
                    <p>Gordon Ramsey Shepards Pie and cider for lunch</p>
                    <img alt="Shepards Pie" class="uitk-image-media" src="/vegasjan/ShepardsPie.jpg" style="width: 17%; height: auto;">                
                </div>
                <div class="text-left">
                    <p>CVS for supplies</p>
                    <img alt="CVS" class="uitk-image-media" src="/vegasjan/CVS.jpg" style="width: 17%; height: auto;">                
                    <p>Some supplies eaten while watching NFL</p>
                    <img alt="NFL" class="uitk-image-media" src="/vegasjan/NFL.jpg" style="width: 17%; height: auto;">                
                    <p>Salmon for dinnner, as I do not like it overcooking it is not an issue)  $36 + $3.02 tax + $10 tip</p>
                    <img alt="Salmon" class="uitk-image-media" src="/vegasjan/Salmon.jpg" style="width: 17%; height: auto;">                
                </div>                
                <div class="text-left">
                    <p>View from room at dusk</p>
                    <img alt="Dusk Viewy" class="uitk-image-media" src="/vegasjan/DuskView.jpg" style="width: 17%; height: auto;">                
                </div>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <a href="https://nextcloud.kangaroosandkoalas.au/index.php/s/HLKLEkP43HbWk3P" download>Room tour</a>
                    <p>You can hear the air conditioning fan at the start of the video.  As the room is so large you cannot hear it in the bedroom or it would be fixed already.</p>
                </div>
            </v-col>   
        </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>